module.exports = __webpack_public_path__ + "img/20191114161835360截图20191114160924478.b533ecc1.jpg";